function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_967",
  "data-name": "Group 967"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_966",
  "data-name": "Group 966"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_665",
  "data-name": "Path 665",
  d: "M137.516,47.533a22.716,22.716,0,1,1,22.716-22.716A22.74,22.74,0,0,1,137.516,47.533Zm0-43.451a20.683,20.683,0,0,0,0,41.367h0a20.683,20.683,0,1,0,0-41.367Z",
  transform: "translate(-114.8 -2.1)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_969",
  "data-name": "Group 969",
  transform: "translate(11.231 15.144)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_968",
  "data-name": "Group 968"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_666",
  "data-name": "Path 666",
  d: "M159.616,35.3a3.405,3.405,0,0,0-3.4-3.4H140.3a3.405,3.405,0,0,0-3.4,3.4v9.1a3.405,3.405,0,0,0,3.4,3.4h15.957a3.405,3.405,0,0,0,3.4-3.4V35.3Zm-13.569,8.334V35.1L152.5,39.37Zm0,0",
  transform: "translate(-136.9 -31.9)",
  fill: "#fff",
  fillRule: "evenodd"
})));

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_970",
    "data-name": "Group 970",
    width: 45.432,
    height: 45.433,
    viewBox: "0 0 45.432 45.433",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.3759cfe5.svg";
export { ForwardRef as ReactComponent };